<template>
  <div class="templateBigScreen2">
    <div class="largeScreenContent">
      <!--标题-->
      <div class="screenTitle">数字能源中心</div>
      <!--时间-->
      <div class="timeBoxTemplateBigScreen2">{{ nowTime }}</div>
      <!--操作-->
      <div class="operatorBox">
        <img v-show="screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/backIcon.png" @click="exitFullscreenClick" />
        <img v-show="!screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/screenIcon.png" @click="enterScreenClick" />
        <img v-show="!screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/editIcon.png" @click="getMainKanbanDataDetailFun()" />
      </div>
      <!--天气-->
      <div class="weatherBoxTemplateBigScreen2">
        <img v-show="currentWeatherObj.weather === '晴'" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather1.png" style="width: 16px; height: 16px" />
        <img
          v-show="currentWeatherObj.weather === '阴' || currentWeatherObj.weather === '多云'"
          alt=""
          src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather2.png"
          style="width: 16px; height: 16px"
        />
        <img
          v-show="currentWeatherObj.weather && currentWeatherObj.weather.includes('雨')"
          alt=""
          src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather3.png"
          style="width: 16px; height: 16px"
        />
        <img
          v-show="currentWeatherObj.weather && currentWeatherObj.weather.includes('雪')"
          alt=""
          src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather4.png"
          style="width: 16px; height: 16px"
        />
        {{ currentWeatherObj.weather }} {{ currentWeatherObj.temperature }}℃ 湿度{{ currentWeatherObj.humidity }}% {{ province }}{{ city }}
        <!--        东经{{ Number(coords.longitude).toFixed(2) }}，北纬 {{ Number(coords.latitude).toFixed(2) }}-->
      </div>
      <!--左边数据展示-->
      <div class="leftBoxTemplateBigScreen2">
        <div class="leftItem leftItem1" v-loading="loadingLeftTop">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/title1.png" />
          </div>
          <div class="leftItemCont">
            <div class="leftItemContTopItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/item0.png" />
              <div>
                <p class="val">{{ pageData.substationAreaNum }}<span class="unit">个</span></p>
                <p class="name">台区数量</p>
              </div>
            </div>
            <div class="leftItemContTop">
              <div class="leftItemContTopItem">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/item1.png" />
                <div>
                  <p class="val">{{ pageData.transformerNum }}<span class="unit">台</span></p>
                  <p class="name">变压器数量</p>
                </div>
              </div>
              <div class="leftItemContTopItem">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/item2.png" />
                <div>
                  <p class="val">{{ pageData.transformerTotalCapacity }}<span class="unit">kVA</span></p>
                  <p class="name">变压器总容量</p>
                </div>
              </div>
              <div class="leftItemContTopItem">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/item2.png" />
                <div>
                  <p class="val">{{ pageData.photovoltaicTotalCapacity }}<span class="unit">KW</span></p>
                  <p class="name">光伏总容量</p>
                </div>
              </div>
              <div class="leftItemContTopItem">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/item2.png" />
                <div>
                  <p class="val">{{ pageData.energyStorageTotalCapacity }}<span class="unit">KW</span></p>
                  <p class="name">储能总容量</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="leftItem leftItem2" v-loading="loadingLeftCenter">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/title2.png" />
          </div>
          <div class="leftItemCont">
            <div class="tabBox">
              <div :class="tabIdx === 1 ? 'tabActive' : ''" class="tabItem" @click="tabClick(1, 'dayElectricCharts')">日</div>
              <div :class="tabIdx === 2 ? 'tabActive' : ''" class="tabItem" @click="tabClick(2, 'monthElectricCharts')">月</div>
              <div :class="tabIdx === 3 ? 'tabActive' : ''" class="tabItem" @click="tabClick(3, 'yearElectricCharts')">年</div>
            </div>
            <div class="echartsBox">
              <div class="barChartRef1"></div>
            </div>
          </div>
        </div>
        <div class="leftItem leftItem3" v-loading="loadingLeftBottom">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/title3.png" />
          </div>
          <div class="leftItemCont">
            <div class="leftItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item5.png" />
              <div class="leftItemContItemRight">
                <div class="val">{{ pageData.reduceCarbonEmissions }}<span class="unit">t</span></div>
                <div class="name">减少碳排放</div>
              </div>
            </div>
            <div class="leftItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item6.png" />
              <div class="leftItemContItemRight">
                <div class="val">{{ pageData.savingStandardCoal }}<span class="unit">t</span></div>
                <div class="name">节约标准煤</div>
              </div>
            </div>
            <div class="leftItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item7.png" />
              <div class="leftItemContItemRight">
                <div class="val">{{ pageData.eqTreesPlanted }}<span class="unit">颗</span></div>
                <div class="name">等效植树数</div>
              </div>
            </div>
            <div class="leftItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item8.png" />
              <div class="leftItemContItemRight">
                <div class="val">{{ pageData.eqGreenCertificate }}<span class="unit">张</span></div>
                <div class="name">等效绿证数</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--中间数据展示-->
      <div class="centerBoxTemplateBigScreen2" v-loading="loadingCenter">
        <!--中间上边数据展示-->
        <div class="centerTopBox">
          <div class="centerTopItem">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/icon1.png" />
              <p class="name">总用电量</p>
            </div>
            <div class="valBox">
              <count-up :end-val="pageData.totalElectric" :options="{ useGrouping: true }" :start-val="countStart1" class="val">
                <template #suffix>
                  <span style="font-size: 12px; letter-spacing: 0">kwh·h</span>
                </template>
              </count-up>
            </div>
          </div>
          <div class="centerTopItem">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/icon2.png" />
              <p class="name">总发电量</p>
            </div>
            <div class="valBox">
              <count-up :end-val="pageData.totalPower" :options="{ useGrouping: true }" :start-val="countStart2" class="val">
                <template #suffix>
                  <span style="font-size: 12px; letter-spacing: 0">kwh·h</span>
                </template>
              </count-up>
            </div>
          </div>
          <div class="centerTopItem">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/icon3.png" />
              <p class="name">总收益</p>
            </div>
            <div class="valBox">
              <count-up :end-val="pageData.totalIncome" :options="{ useGrouping: true }" :start-val="countStart3" class="val">
                <template #suffix>
                  <span style="font-size: 12px; letter-spacing: 0">元</span>
                </template>
              </count-up>
            </div>
          </div>
        </div>
        <!--中间数据展示-->
        <div class="centerBox">
          <!--筛选-->
          <div class="filterBox">
            <el-select v-model="selectId" placeholder="请选择" @change="selecctClick()">
              <el-option v-for="(item, index) in pageData.locationInfo" :key="index" :label="item.projectName" :value="item.moduleId"></el-option>
            </el-select>
            <el-input v-model="inputVal" :suffix-icon="Search" placeholder="站点名称" @input="inputChange"></el-input>
          </div>
          <!--地图-->
          <div id="mapGl" class="mapGl"></div>
        </div>
        <!--中间下边数据展示-->
        <div class="centerBottomBox">
          <div class="centerBottomBoxItem">
            <div class="val">
              <count-up :end-val="pageData.deviceNum" :options="{ useGrouping: true }" :start-val="countStart4" class="val">
                <template #suffix><span class="unit">个</span></template>
              </count-up>
            </div>
            <div class="name">设备数量</div>
          </div>
          <div class="centerBottomBoxItem">
            <div class="val">
              <count-up :end-val="pageData.deviceOnlineNum" :options="{ useGrouping: true }" :start-val="countStart5" class="val">
                <template #suffix><span class="unit">个</span></template>
              </count-up>
            </div>
            <div class="name">在线数量</div>
          </div>
          <div class="centerBottomBoxItem">
            <div class="val">
              <count-up :end-val="pageData.deviceOfflineNum" :options="{ useGrouping: true }" :start-val="countStart6" class="val">
                <template #suffix><span class="unit">个</span></template>
              </count-up>
            </div>
            <div class="name">离线数量</div>
          </div>
          <div class="centerBottomBoxItem">
            <el-progress :percentage="pageData.deviceOnlineRate" color="#0C4DCC" type="circle" />
            <div class="name">在线率</div>
          </div>
          <div class="centerBottomBoxItem">
            <div class="val">
              <count-up :end-val="pageData.deviceDataNum" :options="{ useGrouping: true }" :start-val="countStart7" class="val">
                <template #suffix><span class="unit">条</span></template>
              </count-up>
            </div>
            <div class="name">数据量</div>
          </div>
        </div>
      </div>
      <!--右边数据展示-->
      <div class="rightBoxTemplateBigScreen2">
        <div class="rightItem rightItem1" v-loading="loadingRightTop">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/title4.png" />
          </div>
          <div class="rightItemCont">
            <div class="barChartRef2 chartBox"></div>
          </div>
        </div>
        <div class="rightItem rightItem2" v-loading="loadingRightCenter">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/title5.png" />
          </div>
          <div class="rightItemCont">
            <!-- <div class="sortBox">
              <p>1</p>
              <p>2</p>
              <p>3</p>
              <p>4</p>
              <p>5</p>
            </div> -->
            <div class="barChartRef3 chartBox"></div>
          </div>
        </div>
        <div class="rightItem rightItem3" v-loading="loadingRightBottom">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/title6.png" />
          </div>
          <div class="rightItemCont">
            <div class="circleChartRef chartBox"></div>
          </div>
        </div>
      </div>
    </div>
    <!--选择配置分屏-->
    <el-dialog v-model="selectSetDialog" class="selectSetDialog" title="配置" width="60%">
      <div class="listBox" v-loading="loading">
        <el-select v-model="selectData" multiple>
          <el-option v-for="(item, index) in mainKanbanDataList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="selectSetDialog = false">取消</el-button>
          <el-button type="primary" @click="saveMainKanbanDataDetailFun">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import { defineEmits, defineProps, nextTick, onMounted, onUnmounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import CountUp from "vue-countup-v3";
import * as echarts from "echarts";
import { Search } from "@element-plus/icons-vue";
import { useRoute, useRouter } from "vue-router";
import {
  getGeneralWeatherApi,
  getMainKanbanDataApi,
  getMainKanbanDataApiV2,
  getMainKanbanDataDetailApi,
  getmainViewElectricCharApi,
  getProjectModuleListApi,
  saveMainKanbanDataApi,
  getProjectModuleLIstRecursiveDownApi,
} from "@/api/modules/project";
import { ElMessage, ElLoading } from "element-plus";
import qs from "qs";
import cityCode from "@/assets/js/citycode";
import WebSocketService from "@/pages/project/customComponent/component/websocketService";
import { ws } from "@/api";

const router = useRouter();
const route = useRoute();
const props = defineProps(["screenFlag", "projectModuleId", "showFlag", "custerObj"]);
const emit = defineEmits(["customEvent"]);

moment.locale("zh-cn");

// 实时时间**************************************************************************
let nowTime = ref();
const timer = setInterval(() => {
  nowTime.value = moment().format("YYYY-MM-DD") + "  " + moment().format("dddd") + "  " + moment().format("HH:mm:ss");
}, 1000);

let loading = ref(true);
// 获取模版列表--筛选分屏列表
let mainKanbanDataList = ref([]); //分屏列表
const getTemplateListFun = function () {
  getProjectModuleLIstRecursiveDownApi({
    projectId: props.custerObj.id,
    type: props.showFlag.split("-")[0] == 21 ? 20 : props.showFlag.split("-")[0],
  }).then((res) => {
    if (res.data.code === 0) {
      mainKanbanDataList.value = res.data.result;
      loading.value = false;
    } else {
      ElMessage({
        type: "error",
        message: res.data.message,
      });
    }
  });

  // getProjectModuleListApi(qs.stringify({
  //   projectId: props.custerObj.id
  // })).then(res => {
  //   if (res.data.code === 0) {
  //     let list = JSON.parse(JSON.stringify(res.data.result))
  //     mainKanbanDataList.value = []
  //     for (let i = 0; i < list.length; i++) {
  //       if (list[i].type == 20) {
  //         mainKanbanDataList.value.push(list[i])
  //       }
  //     }
  //   } else {
  //     ElMessage({
  //       type: 'error',
  //       message: res.data.message,
  //     })
  //   }
  // }).catch(err => {
  //   console.log(err);
  // })
};

let selectSetDialog = ref(false);
// 获取配置详情
let selectData = ref([]); //配置的分屏
const getMainKanbanDataDetailFun = function () {
  getMainKanbanDataDetailApi({
    moduleId: props.projectModuleId,
    templateId: 21,
  })
    .then((res) => {
      if (res.data.code === 200) {
        selectSetDialog.value = true;
        let list = JSON.parse(JSON.stringify(res.data.data));
        selectData.value = [];
        for (let i = 0; i < list.length; i++) {
          selectData.value.push(String(list[i].includeModuleId));
        }
      } else {
        ElMessage({
          type: "error",
          message: res.data.message,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

const store = useStore();

// 编辑配置
const saveMainKanbanDataDetailFun = function () {
  let datas = [];
  selectData.value.forEach((item) => {
    console.log(item, mainKanbanDataList.value);
    let dataItem = mainKanbanDataList.value.find((item1) => item == item1.id);
    datas.push({
      includeModuleId: dataItem.id,
      moduleId: props.projectModuleId,
      templateId: store.getters.getTemplateIdByType(dataItem.type) || "",
      type: dataItem.type,
    });
  });

  saveMainKanbanDataApi(datas)
    .then((res) => {
      if (res.data.code === 200) {
        selectSetDialog.value = false;
      } else {
        ElMessage({
          type: "error",
          message: res.data.message,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 选择年月日用电量
let tabIdx = ref(1);
let tabName = ref("dayElectric");
const tabClick = function (idx, key) {
  tabIdx.value = idx;
  tabName.value = key;
  nextTick(() => {
    barChartLoad1();
  });
  return;
  getmainViewElectricCharApi({
    moduleId: props.projectModuleId,
    unit: tabIdx.value === 1 ? "day" : tabIdx.value === 2 ? "month" : "year",
  })
    .then((res) => {
      if (res.data.code === 200) {
        pageData.value = res.data.data;
        nextTick(() => {
          barChartLoad1();
        });
      } else {
        ElMessage({
          type: "error",
          message: res.data.message,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 图表**************************************************************************
// 用电量图表
const barChartLoad1 = function () {
  var chartDom = document.querySelector(".barChartRef1");
  var myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: "",
      left: 16,
      top: 4,
      textStyle: {
        fontSize: 10,
        fontWeight: 300,
      },
    },
    legend: {
      show: false,
      icon: "rect",
      right: 10,
      itemWidth: 10,
      itemHeight: 10,
    },
    grid: {
      left: 50,
      top: 30,
      bottom: 40,
      right: 30,
    },
    tooltip: {
      trigger: "axis", // axis   item   none三个值
      show: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: "#405873",
        },
      },
      data: electricityData.value[tabName.value]?.xAxis ?? [],
    },
    yAxis: {
      type: "value",
      // min: 120000,
      // min: Number(Math.min.apply(null, data.value.powerList)) - Number(Math.min.apply(null, data.value.powerList)) % 10000,
      splitLine: {
        show: true,
        lineStyle: {
          color: ["rgba(62, 122, 248, 0.12)"],
        },
      },
      axisLabel: {
        textStyle: {
          color: "#405873",
        },
      },
    },
    series: [
      {
        name: "用电量",
        type: "line",
        barWidth: 14,
        data: electricityData.value[tabName.value]?.series[0].data ?? [],
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgba(0, 105, 255, 1)",
            },
            {
              offset: 1,
              color: "rgba(0, 105, 255, 0)",
            },
          ]),
        },
        color: "rgba(0, 105, 255, 1)",
      },
    ],
  };
  myChart.clear();
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};
// 光伏储能收益图表
const barChartLoad2 = function () {
  var chartDom = document.querySelector(".barChartRef2");
  var myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: "万元",
      left: 16,
      top: 4,
      textStyle: {
        fontSize: 10,
        fontWeight: 300,
      },
    },
    legend: {
      show: true,
      icon: "rect",
      right: 10,
      itemWidth: 10,
      itemHeight: 10,
    },
    grid: {
      left: 50,
      top: 40,
      bottom: 40,
      right: 30,
    },
    tooltip: {
      trigger: "axis", // axis   item   none三个值
      show: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: true,
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: "#405873",
        },
      },
      data: pageData.value.incomeXAxis,
    },
    yAxis: {
      type: "value",
      // min: 120000,
      // min: Number(Math.min.apply(null, data.value.powerList)) - Number(Math.min.apply(null, data.value.powerList)) % 10000,
      splitLine: {
        show: true,
        lineStyle: {
          color: ["rgba(62, 122, 248, 0.12)"],
        },
      },
      axisLabel: {
        textStyle: {
          color: "#405873",
        },
      },
    },
    series: [
      {
        name: "光伏收益",
        type: "bar",
        data: pageData.value.photovoltaicIncomeSeries[0].data,
        barWidth: 10,
        itemStyle: {
          borderRadius: 5,
        },
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(255, 98, 0, 1)",
          },
          {
            offset: 1,
            color: "rgba(255, 98, 0, 0)",
          },
        ]),
      },
      {
        name: "储能收益",
        type: "bar",
        data: pageData.value.energyStorageIncomeSeries[0].data,
        barWidth: 10,
        itemStyle: {
          borderRadius: 5,
        },
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(0, 166, 255, 1)",
          },
          {
            offset: 1,
            color: "rgba(0, 166, 255, 0)",
          },
        ]),
      },
    ],
  };
  myChart.clear();
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};
// 收益排名图表
const barChartLoad3 = function () {
  // var data = [
  //   { projectName: "撒旦项目", income: 89 },
  //   { projectName: "撒旦发射点深深的反思项目", income: 72 },
  //   { projectName: "撒旦发射项目", income: 65 },
  //   { projectName: "撒旦发射点深项目", income: 93 },
  //   { projectName: "撒旦发射点深深的反项目", income: 81 },
  // ];
  var data = JSON.parse(JSON.stringify(pageData.value.projectIncomeRank));
  for (let i = 0; i < data.length; i++) {
    data[i].value = Number(data[i].income);
    data[i].name = data[i].projectName;
  }

  // 对数据进行排序（从大到小）
  data.sort(function (a, b) {
    return b.value - a.value;
  });
  var chartDom = document.querySelector(".barChartRef3");
  var myChart = echarts.init(chartDom);
  let option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: 10,
      right: 50,
      bottom: 0,
      top: 20,
      containLabel: true,
    },
    xAxis: {
      show: false,
    },
    yAxis: {
      type: "category",
      inverse: true,
      data: data.map(function (item) {
        return item.name;
      }),
      axisTick: {
        // 轴刻度线
        show: false,
      },
      axisLine: {
        // 轴
        show: false,
      },
      // axisLabel: {
      //   interval: 0,
      //   rotate: 0,
      //   formatter: function (value) {
      //     // 自定义格式化
      //     return `${value}`; // 使用富文本
      //   },
      // },
      inverse: true,
      axisLabel: {
        interval: 0,
        padding: [0, 0, 0, -110],
        textStyle: {
          color: "#6B7681",
          align: "left",
          fontSize: 12,
        },
        formatter: (name, index) => {
          let i = data.findIndex((v) => v.name == name);
          const shortName = name.length > 6 ? name.slice(0, 6) + "..." : name;
          if (i == 0) {
            return [`{lg1|${i + 1}} ` + " " + shortName].join("\n");
          } else if (i == 1) {
            return [`{lg2|${i + 1}} ` + " " + shortName].join("\n");
          } else if (i == 2) {
            return [`{lg3|${i + 1}} ` + " " + shortName].join("\n");
          } else {
            return [`{lg|${i + 1}} ` + " " + shortName].join("\n");
          }
        },
        rich: {
          lg1: {
            backgroundColor: "#EF1C1C",
            color: "#fff",
            borderRadius: 4,
            padding: 0,
            align: "center",
            width: 23,
            height: 20,
            lineHeight: 21,
            fontSize: 14,
            fontFamily: "SourceHanSansCN",
          },
          lg2: {
            backgroundColor: "#FD6B22",
            color: "#fff",
            borderRadius: 4,
            padding: 0,
            align: "center",
            width: 23,
            height: 20,
            lineHeight: 21,
            fontSize: 14,
            fontFamily: "SourceHanSansCN",
          },
          lg3: {
            backgroundColor: "#FFB607",
            color: "#fff",
            borderRadius: 4,
            padding: 0,
            align: "center",
            width: 23,
            height: 20,
            lineHeight: 21,
            fontSize: 14,
            fontFamily: "SourceHanSansCN",
          },
          lg: {
            backgroundColor: "#3687F6",
            color: "#fff",
            borderRadius: 4,
            padding: 0,
            align: "center",
            width: 23,
            height: 20,
            lineHeight: 21,
            fontSize: 14,
            fontFamily: "SourceHanSansCN",
          },
        },
      },
    },
    series: [
      {
        name: "数值",
        type: "bar",
        data: data.map(function (item) {
          return item.value;
        }),
        label: {
          show: true,
          position: "right",
          color: "#6B7681",
          formatter: function (params) {
            // 自定义格式化
            return params.value + "万元";
          },
        },
        barWidth: 10,
        itemStyle: {
          borderRadius: 5,
        },
        color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
          {
            offset: 0,
            color: "#12B5F9",
          },
          {
            offset: 1,
            color: "#31CDFC",
          },
        ]),
      },
    ],
  };
  myChart.clear();
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};
// 告警分析图表
const circleChartLoad = function () {
  var data = [
    { name: "xxx项目", value: 89 },
    { name: "xxxxxx项目", value: 72 },
    { name: "x项目", value: 65 },
    { name: "xxx项目", value: 93 },
    { name: "xx项目", value: 81 },
  ];
  // 对数据进行排序（从大到小）
  data.sort(function (a, b) {
    return a.value - b.value;
  });
  var chartDom = document.querySelector(".circleChartRef");
  var myChart = echarts.init(chartDom);
  let option = {
    legend: {
      top: "top",
      icon: "rect",
      itemWidth: 10,
      itemHeight: 10,
    },
    series: [
      {
        name: "",
        type: "pie",
        radius: [30, 90],
        center: ["50%", "50%"],
        roseType: "area",
        itemStyle: {
          borderRadius: 0,
        },
        labelLine: {
          show: true,
        },
        label: {
          show: true, // 隐藏所有标签
          fontSize: 14,
          // formatter: '{c}\n{b}',

          formatter: function (params) {
            return "{value|" + params.value + "}\n{name|" + params.name + "}";
          },
          rich: {
            value: {
              color: "inherit",
              fontSize: 20,
              fontWeight: "bold",
            },
            name: {
              color: "inherit",
              fontSize: 12,
              fontWeight: 400,
            },
          },
        },
        color: ["#F64B4B", "#FF8446", "#FEC12D", "#56D0FF"],
        data: [
          { value: pageData.value.emergencyWarnNum, name: "紧急告警" },
          { value: pageData.value.majorWarnNum, name: "主要告警" },
          { value: pageData.value.minorWarnNum, name: "次要告警" },
          { value: pageData.value.warningWarnNum, name: "警告告警" },
        ],
      },
    ],
  };
  myChart.clear();
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};

// 中上部分累计数据**************************************************************************
let countStart1 = ref(0);
let countStart2 = ref(0);
let countStart3 = ref(0);
let countStart4 = ref(0);
let countStart5 = ref(0);
let countStart6 = ref(0);
let countStart7 = ref(0);

// 中间部分地图**************************************************************************
// 获取地图数据
let mapList = ref([]);
let currentWeatherObj = ref({});
let coords = ref({});
let province = ref();
let city = ref();
// 处理地图数据
const handelMap = async function (lng, lat) {
  var map = new BMap.Map("mapGl");
  var point = new BMap.Point(lng, lat);
  map.centerAndZoom(point, 10);
  map.enableScrollWheelZoom();
  // map.setTilt(70);
  // 样式
  map.setMapStyleV2({
    styleId: "48935f0fcaab6b0c8df31ee5d0b8953f",
  });

  // 给地图加图标
  let list = [
    {
      address: "ddd",
      dailyPowerGeneration: "0.00",
      lat: "30.255952087291817",
      lng: "120.21360559231877",
      name: "test",
      totalCapacity: "30.00",
      totalPowerGeneration: "0.00",
      totalRate: "",
      warnEquipmentNumber: 0,
    },
  ];
  list = pageData.value.locationInfo;

  var infoWindow = [];
  for (let i = 0; i < list.length; i++) {
    var pt = new BMap.Point(list[i].longitude, list[i].latitude);
    var icon;
    let isWarnIcon;
    let isWarn;
    icon = new BMap.Icon("https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/addressIcon.png", new BMap.Size(34, 47));
    isWarnIcon = "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/powerStation/mapIcon3.png";
    isWarn = "none";
    // if (list[i].warnEquipmentNumber == 0) {
    //   icon = new BMap.Icon('https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/addressIcon.png', new BMap.Size(34, 47));
    //   isWarnIcon = 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/powerStation/mapIcon3.png'
    //   isWarn = 'none'
    // } else {
    //   icon = new BMap.Icon('https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/addressIcon.png', new BMap.Size(34, 47));
    //   isWarnIcon = 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/powerStation/mapIcon4.png'
    //   isWarn = 'block'
    // }
    var marker = new BMap.Marker(pt, {
      size: 40,
      icon: icon,
    });
    map.addOverlay(marker);
    var opts = {
      width: 100, // 信息窗口宽度
      height: isWarn === "none" ? 140 : 160, // 信息窗口高度
      // title: "故宫博物院", // 信息窗口标题
      message: "这里是故宫",
      enableMessage: false,
    };
    var itemJson = encodeURIComponent(JSON.stringify(list[i]));
    var sContent = `<div id="info-window-${i}"  onclick="goItem(decodeURIComponent('${itemJson}'))">
        <div style="display: flex;align-items: center">
          <img  alt="" src="${isWarnIcon}"
               style="width: 24px;height: 24px;">
          <div style="margin-left: 8px">
            <p style="font-weight: bold;">${list[i].projectName}</p>
            <p style="font-weight: 400;font-size: 12px;color: #969A9F;">总装机容量：${list[i].photovoltaicCapacity}kwp</p>
          </div>
        </div>
        <div style="font-size: 12px">
          <p>当日发电量：${list[i].dayElectric}度</p>
          <p>总发电量：${list[i].totalPower}KWH</p>
          <p>电站地址：${list[i].address}</p>
        </div>
      </div>`;
    // var infoWindow = new BMap.InfoWindow(sContent, opts);  // 创建信息窗口对象
    infoWindow.push(new BMap.InfoWindow(sContent, opts));
    marker.addEventListener("click", function () {
      map.openInfoWindow(infoWindow[i], new BMap.Point(list[i].longitude, list[i].latitude)); //开启信息窗口
    });
  }
};

// 筛选站点（分屏）
let selectId = ref();
const selecctClick = function () {
  let info = pageData.value.locationInfo.filter((item) => item.moduleId == selectId.value)[0];
  handelMap(info.longitude, info.latitude);
};
// 点击跳转分屏
window.goItem = function (jsonStr) {
  const item = JSON.parse(jsonStr);
  console.log(item, "Clicked!");
  // 处理点击逻辑
  emit("customEvent", item);
  console.log("事件已触发");
};
let inputVal = ref();
const inputChange = function () {
  let info = pageData.value.locationInfo.filter((item) => item.moduleId.includes(inputVal.value));
  handelMap(info[0].longitude, info[0].latitude);
};

// 大屏管理***************************************************************************
let screenFlag = ref(false);
// 点击进入全屏
const enterScreenClick = function () {
  console.log(document.querySelector(".templateBigScreen2"), "llll");
  // 获取layout的dom元素
  const parentNode = document.querySelector(".templateBigScreen2"); // 获取需要全屏的元素;
  console.log(parentNode);
  // 进入全屏
  if (parentNode.requestFullscreen) {
    parentNode.requestFullscreen();
  } else if (parentNode.webkitRequestFullScreen) {
    parentNode.webkitRequestFullScreen();
  } else if (parentNode.mozRequestFullScreen) {
    parentNode.mozRequestFullScreen();
  } else if (parentNode.msRequestFullscreen) {
    // IE11
    parentNode.msRequestFullscreen();
  }
  screenFlag.value = true;
  nextTick(() => {
    // chartLoad()
    setTimeout(() => {
      resizeFun();
    }, 100);
  });
};
// 退出全屏
const exitFullscreenClick = () => {
  const parentNode = document.querySelector(".templateBigScreen2"); // 获取需要全屏的元素;
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
  screenFlag.value = false;
  nextTick(() => {
    // chartLoad()
    setTimeout(() => {
      resizeFun();
    }, 100);
  });
};
watch(
  () => props.screenFlag,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        enterScreenClick();
      });
    }
  },
  { immediate: true, deep: true }
);

// 页面自适应***************************************************************************
const resizeFun = function () {
  nextTick(() => {
    let ele = document.querySelector(".templateBigScreen2");
    let scaleX = ele.clientWidth / 1920;
    let scaleY = ele.clientHeight / 1080;
    document.querySelector(".templateBigScreen2 .largeScreenContent").style.transform = `scale(${scaleX},${scaleY})`;
  });
};
let electricityData = ref({
  dayElectricCharts: {},
  monthElectricCharts: {},
  yearElectricCharts: {},
});
// 获取页面数据
let pageData = ref({
  deviceDataNum: 0,
  deviceNum: 0,
  deviceOfflineNum: 0,
  deviceOnlineNum: 0,
  deviceOnlineRate: 0,
  electricitySeries: [{}],
  electricityXAxis: [{}],

  emergencyWarnNum: 0,
  energyStorageIncomeSeries: [{}],
  energyStorageTotalCapacity: 0,
  eqGreenCertificate: 0,
  eqTreesPlanted: 0,
  incomeXAxis: [{}],
  majorWarnNum: 0,
  minorWarnNum: 0,
  photovoltaicIncomeSeries: [{}],
  photovoltaicTotalCapacity: 0,
  projectIncomeRank: [{}],
  reduceCarbonEmissions: 0,
  savingStandardCoal: 0,
  substationAreaNum: 0,
  totalElectric: 0,
  totalIncome: 0,
  totalPower: 0,
  transformerNum: 0,
  transformerTotalCapacity: 0,
  warningWarnNum: 0,
});
// 新增每个模块的 loading 状态
const loadingLeftTop = ref(false);
const loadingLeftCenter = ref(false);
const loadingLeftBottom = ref(false);
const loadingRightTop = ref(false);
const loadingRightCenter = ref(false);
const loadingRightBottom = ref(false);
// 分模块获取数据，返回 Promise
function fetchBlockData(blockName, loadingRef, dataKey) {
  loadingRef.value = true;
  return getMainKanbanDataApiV2({
    moduleId: props.projectModuleId,
    templateId: 9999999991,
    blockName,
  })
    .then((res) => {
      if (res.data.code === 200) {
        Object.assign(pageData.value, res.data.data || {});
      } else {
        ElMessage({ type: "error", message: res.data.message });
      }
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      loadingRef.value = false;
    });
}

const getMainKanbanDataFun = function () {
  countStart1.value = pageData.value.totalElectric;
  countStart2.value = pageData.value.totalPower;
  countStart3.value = pageData.value.totalIncome;
  countStart4.value = pageData.value.deviceNum;
  countStart5.value = pageData.value.deviceOnlineNum;
  countStart6.value = pageData.value.deviceOfflineNum;
  countStart7.value = pageData.value.deviceDataNum;
  Promise.all([
    fetchBlockData("leftTop", loadingLeftTop),
    fetchBlockData("leftCenter", loadingLeftCenter),
    fetchBlockData("leftBottom", loadingLeftBottom),
    fetchBlockData("rightTop", loadingRightTop),
    fetchBlockData("rightCenter", loadingRightCenter),
    fetchBlockData("rightBottom", loadingRightBottom),
  ]).then(() => {
    for (const key in electricityData.value) {
      if (electricityData.value[key]) {
        electricityData.value[key] = pageData.value[key];
      }
    }
    nextTick(() => {
      barChartLoad1();
      barChartLoad2();
      barChartLoad3();
      circleChartLoad();
      // 获取地图数据
      if (pageData.value.locationInfo && pageData.value.locationInfo.length > 0) {
        handelMap(pageData.value.locationInfo[0].longitude, pageData.value.locationInfo[0].latitude);
      }
    });
  });

  return;
  getMainKanbanDataApi({
    moduleId: props.projectModuleId,
    templateId: 9999999991,
  })
    .then((res) => {
      if (res.data.code === 200) {
        countStart1.value = pageData.value.totalElectric;
        countStart2.value = pageData.value.totalPower;
        countStart3.value = pageData.value.totalIncome;
        countStart4.value = pageData.value.deviceNum;
        countStart5.value = pageData.value.deviceOnlineNum;
        countStart6.value = pageData.value.deviceOfflineNum;
        countStart7.value = pageData.value.deviceDataNum;
        pageData.value = res.data.data;

        for (const key in electricityData.value) {
          if (electricityData.value[key]) {
            electricityData.value[key] = res.data.data[key];
          }
        }
        nextTick(() => {
          barChartLoad1();
          barChartLoad2();
          barChartLoad3();
          circleChartLoad();
          // 获取地图数据
          handelMap(pageData.value.locationInfo[0].longitude, pageData.value.locationInfo[0].latitude);
        });
      } else {
        ElMessage({
          type: "error",
          message: res.data.message,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
let dataTimer = setInterval(() => {
  getMainKanbanDataFun();
}, 1000 * 60 * 5);

// ws连接*********************************************************
// const wsService = new WebSocketService('ws://192.168.3.11:8088/ws/blockScreen'); // 使用wss或ws协议根据你的服务器配置选择安全或不安全连接方式。
const wsService = new WebSocketService(ws + "ws/blockScreen"); // 使用wss或ws协议根据你的服务器配置选择安全或不安全连接方式。
// 连接WebSocket---------------
wsService.connect();

// 监听接收的数据---------------
// 自定义防抖函数
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

// 创建防抖处理函数
const debouncedUpdate = debounce((event) => {
  // console.log(event, '防抖处理后的事件');
  if (event && event !== {}) {
    countStart1.value = pageData.value.totalElectric;
    countStart2.value = pageData.value.totalPower;
    countStart3.value = pageData.value.totalIncome;
    countStart4.value = pageData.value.deviceNum;
    countStart5.value = pageData.value.deviceOnlineNum;
    countStart6.value = pageData.value.deviceOfflineNum;
    countStart7.value = pageData.value.deviceDataNum;

    pageData.value.totalElectric = event.totalElectric;
    pageData.value.totalPower = event.totalPower;
    pageData.value.totalIncome = event.totalIncome;
    pageData.value.deviceNum = event.deviceNum;
    pageData.value.deviceOnlineNum = event.deviceOnlineNum;
    pageData.value.deviceOfflineNum = event.deviceOfflineNum;
    pageData.value.deviceDataNum = event.deviceDataNum;
    pageData.value.deviceOnlineRate = event.deviceOnlineRate;
  }
}, 1000);
wsService.addMessageListener(debouncedUpdate); // 添加监听器以接收消息。

// 发送数据---------------
function sendMessage() {
  wsService.send({ moduleId: props.projectModuleId, templateId: 9999999991 }); // 发送消息到服务器。确保服务器可以解析这种格式。
}

// 监听连接状态---------------
let timer2;
wsService.addStatusListener(({ status, data }) => {
  // console.log('WebSocket status changed:', status, data);
  // 连接成功后发送消息
  if (status === "connected") {
    sendMessage();
    timer2 = setInterval(() => {
      wsService.send({ heart: 1 });
    }, 10000);
  }
  if (status === "error") {
    console.error("WebSocket error occurred:", data);
    clearInterval(timer2);
  }
});

watch(
  () => props.projectModuleId,
  (newVal) => {
    // currentWeatherFun()
    getTemplateListFun();
    getMainKanbanDataFun();
    wsService.connect();
    nextTick(() => {
      barChartLoad1();
      barChartLoad2();
      barChartLoad3();
      circleChartLoad();
    });

    resizeFun();
    window.onresize = () => {
      nextTick(() => {
        setTimeout(() => {
          resizeFun();
        }, 100);
      });
    };

    // 获取当前位置经纬度----根据经纬度获取地址----根据地址获取天气
    // navigator.geolocation.getCurrentPosition(
    //   (position) => {
    //     coords.value = {
    //       latitude: position.coords.latitude,
    //       longitude: position.coords.longitude,
    //     };
    //     // 根据坐标获取地址======>用当前位置获取天气
    //     new BMap.Geocoder().getLocation(new BMap.Point(coords.value.longitude, coords.value.latitude), (result) => {
    //       if (result) {
    //         // console.log("详细地址：", result.address);
    //         console.log("结构化信息：", result.addressComponents);
    //         province.value = result.addressComponents.province;
    //         city.value = result.addressComponents.city;

    //         // 筛选出城市编码用于获取天气
    //         let code = cityCode.filter((item) => item.name === city.value)[0].adcode;
    //         getGeneralWeatherApi(code, "base")
    //           .then((res) => {
    //             if (res.data.status === "1") {
    //               currentWeatherObj.value = res.data.lives[0];
    //               console.log(currentWeatherObj.value, "实时");
    //             } else {
    //               ElMessage({
    //                 message: res.data.code,
    //                 type: "error",
    //               });
    //             }
    //           })
    //           .catch((err) => {
    //             console.log(err);
    //           });
    //       } else {
    //         console.error("逆地理编码失败");
    //       }
    //     });
    //   },
    //   (err) => {
    //     error.value = err.message;
    //   }
    // );
  }
);

onMounted(() => {
  // currentWeatherFun()
  getTemplateListFun();
  getMainKanbanDataFun();
  wsService.connect();
  nextTick(() => {
    barChartLoad1();
    barChartLoad2();
    barChartLoad3();
    circleChartLoad();
  });

  resizeFun();
  window.onresize = () => {
    nextTick(() => {
      setTimeout(() => {
        resizeFun();
      }, 100);
    });
  };

  // 获取当前位置经纬度----根据经纬度获取地址----根据地址获取天气
  navigator.geolocation.getCurrentPosition(
    (position) => {
      coords.value = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
      // 根据坐标获取地址======>用当前位置获取天气
      new BMap.Geocoder().getLocation(new BMap.Point(coords.value.longitude, coords.value.latitude), (result) => {
        if (result) {
          // console.log("详细地址：", result.address);
          console.log("结构化信息：", result.addressComponents);
          province.value = result.addressComponents.province;
          city.value = result.addressComponents.city;

          // 筛选出城市编码用于获取天气
          let code = cityCode.filter((item) => item.name === city.value)[0].adcode;
          getGeneralWeatherApi(code, "base")
            .then((res) => {
              if (res.data.status === "1") {
                currentWeatherObj.value = res.data.lives[0];
                console.log(currentWeatherObj.value, "实时");
              } else {
                ElMessage({
                  message: res.data.code,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.error("逆地理编码失败");
        }
      });
    },
    (err) => {
      error.value = err.message;
    }
  );
});

onUnmounted(() => {
  clearInterval(timer);
  clearInterval(timer2);
  clearInterval(dataTimer);
  wsService.disconnect();
});
</script>

<style lang="less">
@font-face {
  font-family: Title;
  src: url("https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/title.ttf");
}

.templateBigScreen2 {
  width: 100%;
  height: 100%;

  .largeScreenContent {
    width: 1920px;
    height: 1080px;
    transform-origin: 0% 0%;
    position: relative;
    background: url("https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen2/background.png") no-repeat 0 0;
    background-size: 100% 100%;

    //标题
    .screenTitle {
      position: absolute;
      top: 8px;
      width: 100%;
      font-family: Title;
      font-size: 37px;
      color: #0c4dcc;
      line-height: 48px;
      text-align: center;
    }

    //操作
    .operatorBox {
      position: absolute;
      left: 20px;
      top: 51px;
      height: 28px;
      display: flex;

      img {
        width: 28px;
        height: 28px;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    //时间
    .timeBoxTemplateBigScreen2 {
      position: absolute;
      top: 24px;
      left: 21px;
      font-size: 16px;
      color: #48637e;
    }

    //天气
    .weatherBoxTemplateBigScreen2 {
      position: absolute;
      top: 32px;
      right: 38px;
      font-size: 16px;
      color: #48637e;
    }

    //左边数据展示
    .leftBoxTemplateBigScreen2 {
      width: 390px;
      height: 967px;
      position: absolute;
      top: 89px;
      left: 20px;

      .leftItem {
        width: 390px;
        height: 309px;
        margin-bottom: 20px;

        .itemTitle {
          width: 388px;
          height: 45px;
          margin-bottom: 10px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .itemTitleRight {
            position: absolute;
            top: 0;
            right: 20px;
            height: 45px;
            line-height: 45px;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
        }

        .leftItemCont {
          width: 390px;
          height: 254px;
          background: linear-gradient(90deg, #e5f0ff 0%, rgba(255, 255, 255, 0.7) 100%);
          box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
          border-radius: 0px 0px 30px 30px;
          border: 1px solid;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
        }
      }

      .leftItem1 {
        .leftItemCont {
          > .leftItemContTopItem {
            margin: 19px 0 10px;
            justify-content: center;
            width: 100% !important;
          }

          .leftItemContTop {
            height: calc(100% - 100px);
            display: flex;
            justify-content: space-around;
            align-content: space-around;
            flex-wrap: wrap;

            > .leftItemContTopItem:nth-child(odd) img {
              margin-left: 20px;
            }
          }

          .leftItemContTopItem {
            display: flex;
            align-items: center;
            height: 56px;
            width: 50%;

            img {
              width: 40px;
              height: 40px;
              margin-right: 8px;
            }

            > div {
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .name {
                font-weight: 400;
                font-size: 12px;
                color: #728294;
              }

              .val {
                font-weight: bold;
                font-size: 36px;
                color: #333333;
                height: 36px;
                line-height: 36px;
              }

              .unit {
                font-weight: 500;
                font-size: 12px;
                color: #455464;
              }
            }
          }
        }
      }

      .leftItem2 {
        .leftItemCont {
          .tabBox {
            width: 108px;
            height: 24px;
            margin: 10px 17px;
            display: flex;
            border: 1px solid #eeeeee;
            border-radius: 4px;

            .tabItem {
              width: 36px;
              height: 24px;
              text-align: center;
              line-height: 24px;
              font-weight: 400;
              font-size: 12px;
              color: #333333;
              background: #fff;
              cursor: pointer;
            }

            .tabActive {
              background: #0066ff;
              color: #fff;
            }

            .tabItem:nth-child(1) {
              border-radius: 4px 0px 0px 4px;
            }

            .tabItem:nth-child(2) {
              border-left: 1px solid #eeeeee;
              border-right: 1px solid #eeeeee;
            }

            .tabItem:nth-child(3) {
              border-radius: 0px 4px 4px 0px;
            }
          }

          .echartsBox {
            width: 100%;
            height: calc(100% - 46px);

            .barChartRef1 {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .leftItem3 {
        margin-bottom: 0;

        .leftItemCont {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          align-content: space-around;

          .leftItemContItem {
            display: flex;
            //justify-content: center;
            align-items: center;
            width: 50%;

            img {
              width: 40px;
              height: 40px;
              margin-right: 8px;
              margin-left: 20px;
            }

            .leftItemContItemRight {
              .val {
                height: 36px;
                line-height: 36px;
                font-weight: bold;
                font-size: 36px;
                color: #333333;

                .unit {
                  font-size: 12px;
                }
              }

              .name {
                font-weight: 400;
                font-size: 12px;
                color: #728294;
              }
            }
          }
        }
      }
    }

    //中间数据展示
    .centerBoxTemplateBigScreen2 {
      //中上数据
      .centerTopBox {
        width: 1059px;
        height: 96px;
        position: absolute;
        left: 430px;
        top: 89px;
        display: flex;
        justify-content: space-between;

        .centerTopItem {
          padding: 12px;
          width: 313px;
          height: 72px;
          border-radius: 4px;

          .tit {
            display: flex;

            img {
              width: 20px;
              height: 20px;
              margin-right: 8px;
            }

            .name {
              font-weight: bold;
              font-size: 14px;
              color: #ffffff;
            }
          }

          .valBox {
            .val {
              letter-spacing: 2px;
              text-align: center;
              font-size: 30px;
              font-family: OPPOSans B;
              color: #ffffff;
            }
          }
        }

        .centerTopItem:nth-child(1) {
          background: linear-gradient(90deg, #4ecbf3 0%, #1099ed 100%);
          box-shadow: 4px 4px 6px 0px rgba(24, 74, 89, 0.12);
        }

        .centerTopItem:nth-child(2) {
          background: linear-gradient(90deg, #629df4 0%, #5571f5 100%);
          box-shadow: 4px 4px 6px 0px rgba(89, 62, 24, 0.12);
        }

        .centerTopItem:nth-child(3) {
          background: linear-gradient(90deg, #efbc4d 0%, #eb7e50 100%);
          box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
        }
      }

      //中间数据
      .centerBox {
        .filterBox {
          position: absolute;
          z-index: 9;
          left: 1271px;
          top: 212px;
          width: 200px;
          height: 114px;
          background: rgba(12, 77, 204, 0.7);
          box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
          border-radius: 6px;
          border: 1px solid;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .el-input,
          .el-select {
            width: 168px;
            height: 32px;
            border-radius: 6px;
            border: 0;

            .el-input__wrapper,
            .el-select__wrapper {
              background: rgba(255, 255, 255, 0.2);
              border: 1px solid #ffffff;
            }

            .el-input__inner::placeholder {
              color: #fff;
              opacity: 1; /* Firefox 需要设置 opacity */
            }

            .el-select__placeholder,
            .el-icon {
              color: #fff;

              span {
                color: #fff;
              }
            }
          }

          .el-select {
            margin-bottom: 10px;
          }
        }

        .mapGl {
          position: absolute;
          left: 430px;
          top: 192px;
          width: 1061px;
          height: 864px;
        }
      }

      //中下数据
      .centerBottomBox {
        width: 1050px;
        height: 114px;
        position: absolute;
        left: 435px;
        top: 922px;
        display: flex;
        justify-content: space-between;

        .centerBottomBoxItem {
          //width: 200px;
          flex: 2;
          margin-right: 10px;
          height: 114px;
          background: linear-gradient(90deg, #e5f0ff 0%, rgba(255, 255, 255, 0.7) 100%);
          box-shadow: 0px 0px 10px 0px rgba(67, 143, 234, 0.18);
          border-radius: 6px;
          border: 1px solid rgba(11, 77, 204, 0.44);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .val {
            text-align: center;
            font-size: 28px;
            color: #0c4dcc;

            .unit {
              font-size: 12px;
            }
          }

          .el-progress,
          .el-progress .el-progress-circle,
          .el-progress .el-progress-circle svg {
            width: 66px;
            height: 66px;
          }

          .el-progress {
            .el-progress__text span {
              font-weight: bold;
              font-size: 14px;
              color: #0c4dcc;
            }

            svg > path:nth-child(1) {
              stroke: rgba(216, 216, 216, 0.2); // #write 此处的id就是定义的svg标签id 做替换即可
            }
          }

          .name {
            font-weight: 400;
            font-size: 14px;
            color: #455464;
          }
        }

        .centerBottomBoxItem:first-of-type {
          flex: 3;
        }

        .centerBottomBoxItem:last-of-type {
          margin-right: 0;
          flex: 5;
        }
      }
    }

    //右边数据展示
    .rightBoxTemplateBigScreen2 {
      width: 390px;
      height: 967px;
      position: absolute;
      top: 89px;
      right: 20px;

      .rightItem {
        width: 390px;
        height: 309px;
        margin-bottom: 20px;

        .itemTitle {
          width: 388px;
          height: 45px;
          margin-bottom: 10px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .rightItemCont {
          width: 390px;
          height: 254px;
          background: linear-gradient(90deg, #e5f0ff 0%, rgba(255, 255, 255, 0.7) 100%);
          box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
          border-radius: 0px 0px 30px 30px;
          border: 1px solid;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;

          .chartBox {
            width: 100%;
            height: 238px;
            margin-top: 16px;
          }
        }
      }

      .rightItem1 {
      }

      .rightItem2 {
        .rightItemCont {
          display: flex;

          .sortBox {
            width: 20px;
            margin-left: 12px;
            margin-right: 3px;

            p {
              width: 20px;
              height: 20px;
              border-radius: 4px;
              text-align: center;
              line-height: 20px;
              color: #fff;
              font-size: 14px;
              margin-top: 23px;
            }

            p:nth-child(1) {
              background: #ef1c1c;
              margin-top: 32px;
            }

            p:nth-child(2) {
              background: #fd6b22;
            }

            p:nth-child(3) {
              background: #ffb607;
            }

            p:nth-child(4),
            p:nth-child(5) {
              background: #3687f6;
            }
          }

          .chartBox {
            // width: calc(100% - 35px);
            height: 100%;
            margin-top: 0;
          }
        }
      }

      .rightItem3 {
        margin-bottom: 0;

        .rightItemCont {
        }
      }
    }
  }
}
</style>
